import { Component, inject, input, OnInit, signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ReCaptchaService } from '@core/services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { InputComponent } from '@shared/components/form-fields/input/input.component';
import { HowToPlayComponent } from '@shared/components/how-to-play/how-to-play.component';
import { TemplateComponent } from '@shared/components/template/template.component';
import {
  AuthProgrammeCard,
  AuthSecondVariantConfig,
  ChondrusAuthPayload,
} from '@shared/models';

import { AuthBaseComponent } from '../auth.base.component';

@Component({
  selector: 'b2c-variant2',
  styleUrl: './variant2.component.scss',
  templateUrl: './variant2.component.html',
  imports: [
    RouterLink,
    FormsModule,
    InputComponent,
    ButtonComponent,
    FooterComponent,
    TemplateComponent,
    HowToPlayComponent,
    ReactiveFormsModule,
  ],
})
export class Variant2Component extends AuthBaseComponent implements OnInit {
  config = input.required<AuthSecondVariantConfig>();

  public readonly isSecretVisible = signal(false);

  private _signinForm: FormGroup = new FormGroup({});
  private readonly reCaptchaService = inject(ReCaptchaService);

  get form(): FormGroup {
    return this._signinForm;
  }

  ngOnInit(): void {
    this._signinForm = this.initForm(this.config().loginBlock.fields);
  }

  isProgrammeShown(programme: AuthProgrammeCard): boolean {
    return (
      !programme.requiresBisCampaign ||
      (this.environment.hasCampaignBis &&
        this.dataService.hasCurrentBisCampaign())
    );
  }

  toggleSecretVisibility(): void {
    this.isSecretVisible.update((isVisible) => !isVisible);
  }

  submit(): void {
    if (this.formSubmitted()) {
      return;
    }

    if (this.form.invalid) {
      this.showErrorMessage.set(true);
      return;
    }

    this.formSubmitted.set(true);
    this.showErrorMessage.set(false);

    const payload: ChondrusAuthPayload = this.form.value;

    if (this.environment.reCAPTCHAKey) {
      const reCAPTCHAKey = this.environment.reCAPTCHAKey;
      this.reCaptchaService
        .getToken(reCAPTCHAKey, this.environment)
        .then((token: string) => {
          payload.recaptcha_token = token;
          this.authenticate(payload);
        });
    }
  }
}
